
export enum QuyHoachActionType {
  ChonGiaiDoan='ChonGiaiDoan',
  ThongTinQuyHoach_ChonHanhChinh = 'ThongTinQuyHoach_ChonHanhChinh',
  ThongTinQuyHoach_ChonLoaiQuyHoach = 'ThongTinQuyHoach_ChonLoaiQuyHoach',
  ThongTinQuyHoach_ChonQuyHoach = 'ThongTinQuyHoach_ChonQuyHoach',
  ThongTinQuyHoach_ChonLoaiQuyHoach_SUCCESS = 'ThongTinQuyHoach_ChonLoaiQuyHoach_SUCCESS',
  ThongTinQuyHoach_DanhMucHoSo_THEM = 'ThongTinQuyHoach_DanhMucHoSo_THEM',
  ThongTinQuyHoach_TepDinhKem = 'ThongTinQuyHoach_TepDinhKem',
  ThongTinQuyHoach_DanhMucHoSo_SELECTED = 'ThongTinQuyHoach_DanhMucHoSo_SELECTED',
  GopYQuyHoach_NhapNoiDungGopY = 'GopYQuyHoach_NhapNoiDungGopY',
};